(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'es', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelectorAll('[data-pack]').forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
    }));
    root.querySelectorAll('[data-pack]').forEach(card => {
      const selects = [...card.querySelectorAll('[data-variant]')];
      const button = card.querySelector('[data-add-pack]');
      const status = card.querySelector('[role="status"]');
      const label = button.textContent;
      const consent = card.querySelector('[data-pack-consent]');
      function update() {
        const options = selects.map(select => select.selectedOptions[0]);
        const subtotal = options.reduce((sum, option) => sum + Number(option?.dataset.price || 0), 0);
        const discount = Math.min(Math.max(0, Number(card.dataset.discount || 0)), Math.max(0, subtotal - 1));
        card.querySelector('[data-price-total]').textContent = formatter.format((subtotal - discount) / 100);
        const before = card.querySelector('[data-price-before]');
        before.hidden = discount === 0;
        before.textContent = formatter.format(subtotal / 100);
        card.querySelector('[data-saving]').hidden = discount === 0;
        card.querySelector('[data-saving-value]').textContent = formatter.format(discount / 100);
        button.disabled = options.some(option => !option || option.dataset.available !== 'true');
      }
      selects.forEach(select => select.addEventListener('change', update));
      update();
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        if (consent && !consent.checked) { status.textContent = root.dataset.accept; consent.focus(); return; }
        button.disabled = true;
        button.textContent = root.dataset.loading;
        status.textContent = '';
        try {
          const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: selects.map(select => ({ id: Number(select.value), quantity: 1, ...(consent && select.dataset.digital === 'true' ? { properties: { '_Consentimiento contenido digital': root.dataset.orderConsent } } : {}) })) }) });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          status.textContent = root.dataset.error;
          button.textContent = label;
          update();
        }
      });
    });
  }
  document.querySelectorAll('[data-be-packs]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-be-packs]').forEach(init));
})();
